module.exports = __webpack_public_path__ + "fonts/EuclidEnercity-MediumItalic-WebS.70b944b7.ttf";